$(document).ready(function() {
	setTimeout(ready, 200);
})

var ready = (function() {
//--- code moved to /shop/directives/owl-carousel-directive.js
	// Owl Carousel
// var $owl = $('.prodCarousel');
// $owl.owlCarousel({
//       responsiveClass:true,
//       dots:true,

//       responsiveBaseElement:".owl-theme",
//       responsive:{
//           0:{items:1, },
//           400:{items:2, },
//           600:{items:3, },
//           800:{items:4, },
//           1000:{items:5, },
//           1200:{items:6, }
//       }


//   })




// $("#home #wrapper,#homeFeatured #wrapper").on("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend",
//               function(event) {
//     owlres();

//   });

//   function owlres() {
//           //var owl =  $owl.data('owl.carousel');
//           //owl.onResize();
//        $owl.data('owl.carousel')._invalidated.width = true;
//       $owl.trigger('refresh.owl.carousel');

//   }



//   // Menu Left -  Toggle Script

//   $("#menu-toggle,#menu-toggle-mobile").click(function(e) {
//       e.preventDefault();
//       $("#wrapper").toggleClass("closed");
//       $("body").toggleClass("menuOpen");
//       e.preventDefault();
//       $('#menuOverlay').fadeIn("fast");



//   });

//    $('#menuOverlay').click(function() {
//     $('#menuOverlay').fadeOut('fast');
//     $("#wrapper").addClass("closed");
//     $("body").removeClass("menuOpen");

//   });

//    $('.cart .dropdown-toggle').click(function() {
//     $('#menuOverlay').fadeOut('fast');
//     $("#wrapper").addClass("closed");
//     $("body").removeClass("menuOpen");


//   });
//--- end code moved to /shop/directives/owl-carousel-directive.js

//--- code moved to /shop/components/cart/cart.es6
	// $('.cart .dropdown-toggle').dropdown();
	// $('.cart .dropdown-toggle').click(function(e) {
	//   $('.btn-group.cart #sideCart.dropdown-menu').toggleClass("block");
	//     $("#wrapper").addClass("closed");
	//     $("body").removeClass("menuOpen");
	//     $("body").toggleClass("cartOpen");
	//   e.preventDefault();
	//   $('#overlay').fadeToggle( "fast", "swing" );
	// });
	// $('#overlay,#navbar-main, nav.navbar.mobile').click(function() {
	//   $('#overlay').fadeOut('fast');
	//   $('.btn-group.cart #sideCart.dropdown-menu').removeClass("block");
	//   $("body").removeClass("cartOpen");
	// });
	// $('#overlay').click(function() {

	//   //$('#sideCart').css('display', "none");
	// });

//--- end code moved to /shop/components/cart/cart.es6


	//affix class for sticky header (homepage) moved inline using data-xxx attributes
// 	setTimeout(function() {

// 	var affixElement = '#home #navbar-main';

// 	$(affixElement).affix({
// 	  offset: {
// 	    // Distance of between element and top page
// 	    top: function () {
// 	      return (this.top = $(affixElement).offset().top)
// 	    }
// 	  }
// 	});
// },200)



	// disable close-on-click inside dropdown menu (cart)
	$('.cart .dropdown-menu').on('click', function(event){
			var events = $._data(document, 'events') || {};
			events = events.click || [];
			for(var i = 0; i < events.length; i++) {
					if(events[i].selector) {

							//Check if the clicked element matches the event selector
							if($(event.target).is(events[i].selector)) {
									events[i].handler.call(event.target, event);
							}

							// Check if any of the clicked element parents matches the
							// delegated event selector (Emulating propagation)
							$(event.target).parents(events[i].selector).each(function(){
									events[i].handler.call(this, event);
							});
					}
			}
			// event.stopPropagation(); //Always stop propagation
	});




// Define width to .blocTitle

//   $(window).on('load resize scroll', function(){
//    	var titleWidth =  $('#titlePage').width()/2;
//	        $('.blocTitle').css('margin-left', -titleWidth); //center title
//	});



// Define leftMenu Height

		//  $(window).on('load resize scroll', function(){
		// 	var heightbottomMenu = $('nav.mobile').height()+70;
		// 		var heightBody =  window.innerHeight;
		// 		var heighttopMenu =  $('.sidebar-brand').height() + 180;
		// 		var heightleftMenu =  heightBody - heighttopMenu - heightbottomMenu ;
		// 				$('#sideMenu').css('height', heightleftMenu); //center title
		// });












	// Add class to body with multiple modal connexion /subscribe
		// var $body = $('body')
		// $("a.nextstep").click(function(){
		//  $body.addClass('modal1-on')
		// });
		// $("a.previousstep").click(function(){
		//  $body.addClass('modal2-on')
		// });
		// $("a#forgotPass").click(function(){
		//  $body.addClass('modal3-on')
		// });

		// $('#modal-connexion').on('hidden.bs.modal', function () {
		// $body.removeClass('modal2-on')
		// });
		// $('#modal-subscribe').on('hidden.bs.modal', function () {
		// $body.removeClass('modal1-on')
		// });
		// $('#modal-forgotPass').on('hidden.bs.modal', function () {
		// $body.removeClass('modal1-on')
		// $body.removeClass('modal2-on')
		// $body.removeClass('modal3-on')
		// });




// RESPONSIVE MODERNIZR

//  var scMobile = Modernizr.mq('(max-width: 767px)');
// if (scMobile) {
// // Define cart Height

//     $(window).on('load resize ', function(){
//       var heightbottomMenu = $('nav.mobile').height();
//       var heightBody =  window.innerHeight;
//       var heightHeader =  $('#navbar-main').height();
//       var heightCart =  heightBody - heightHeader - heightbottomMenu;
//           $('#sideCart').css('height', heightCart); //center title

//     $('#cartContent').css('height',  (heightCart * 55) /100); //center title

//    });
//   }

// else {

//   // Define cart Height

//      $(window).on('load resize ', function(){
//         var heightbottomMenu = $('nav.mobile').height();
//         var heightBody =  window.innerHeight;
//         var heightHeader =  $('#navbar-main').height();
//         var heightCart =  heightBody - heightHeader - heightbottomMenu;
//             $('#sideCart').css('height', heightCart); //center title
//     });

// // Define cart selection Height

//     $('.btn-group.cart').on('show.bs.dropdown shown.bs.dropdown', function () {
//     var newheightCart = $('#sideCart').height() - 30;
//      var newheightbottomMenu = $('nav.mobile').height();
//         var heightTopCart =  document.getElementById('topCart').offsetHeight;
//         var heightBottomCart  =  document.getElementById('totalCart').offsetHeight;
//         var heightInsideCart =  newheightCart - heightBottomCart - heightTopCart - newheightbottomMenu;
//             $('#cartContent').css('height', heightInsideCart); //center title

//         $(window).on('load resize ', function(){
//           var resizeheightCart = $('#sideCart').height() - 30;
//            var reheightbottomMenu = $('nav.mobile').height();
//           var newheightTopCart =  document.getElementById('topCart').offsetHeight;
//           var newheightBottomCart  =  document.getElementById('totalCart').offsetHeight;
//           var newheightInsideCart =  resizeheightCart - newheightBottomCart - newheightTopCart - reheightbottomMenu;
//             $('#cartContent').css('height', newheightInsideCart); //center title
//       });
//     });

// }









		 var scTabletP = $(document).width() >= 768;

				if (scTabletP) {
					 $('.modalProd').on('shown.bs.modal', function (e) {
							 var offsetHeight = document.getElementById('bigImg').offsetHeight;
							 var offsetHeightTxt = document.getElementById('popTxt').offsetHeight;
							 var scDesktopHeight = offsetHeight + offsetHeightTxt;
							 $('.modal-dialog').css('max-height', scDesktopHeight); //set max height
							 $('.modal-dialog').css('height', 'inherit');

							 $(window).on('resize', function(){
								$('.modalProd').modal('hide')
						});
					});
				 };




				 var scDesktop = $(document).width() >= 1024;
				 if (scDesktop) {

				 };

//--- code moved to /shop/layout/sidebar-controller.es6
				 // $(function() {
				 //        // Call on every window resize
				 //        //Open menu left on all pages close it on Home page
				 //        $(window).resize(function(){
				 //            if (Modernizr.mq('(min-width: 1024px)')) {
				 //              $("body").addClass("menuOpen");
				 //              $("#wrapper").removeClass("closed");
				 //              $("body#home").removeClass("menuOpen");
				 //              $("#home #wrapper").addClass("closed");
				 //            }
				 //            else {
				 //             $("body").removeClass("menuOpen");
				 //             $("#wrapper").addClass("closed");
				 //           };
				 //        }).resize();   // Cause an initial widow.resize to occur
				 //    });
//--- end code moved to /shop/layout/sidebar-controller.es6






		 var scDesktopHD = $(document).width() >= 1800;
			if (scDesktopHD) {

					// Define max-height to .modalProd
					$('.modalProd').on('shown.bs.modal', function (e) {
							var offsetHeight = document.getElementById('bigImg').offsetHeight;
							$('.modal-dialog').css('max-height', offsetHeight); //set max height
							$('.modal-dialog').css('height', '100%');

								$(window).on('resize', function(){
								 $('.modalProd').modal('hide')
						 });

					});
			};





// $(window).on('load resize', function(){
// 		return;


// 	    var widthProdImg = $(".prodImg a > img").width();
// 	    var widthProdBlock = $(".prodImg").width();
// 	    var coefWidth = widthProdBlock / widthProdImg;

// 	    var heightProdImg = $(".prodImg a > img").height();
// 	    var heightProdBlock = $(".prodImg").height();
// 	    var coefheight = heightProdBlock / heightProdImg;

// 	    if (widthProdImg < widthProdBlock) {
// 	    	$(".prodImg a > img").css({transform: 'scale(' + coefWidth + ')'});
// 	    };

// 	    if (heightProdImg < heightProdBlock) {
// 	    	$(".prodImg a > img").css({transform: 'scale(' + coefheight + ')'});
// 	    };
// });





}); // end (document).ready fonction



/* Start Image Scale Code */
// function image_scale() {
// 	return;
//     $(".prodImg img").each(function(i, item) {

//         var widthProdImg = $(this).width();
// 	    var widthProdBlock = $(this).parent().width();
// 	    var coefWidth = widthProdBlock / widthProdImg;

// 	    var heightProdImg = $(this).height();
// 	    var heightProdBlock = $(this).parent().height();
// 	    var coefheight = heightProdBlock / heightProdImg;

// 	    if (widthProdImg < widthProdBlock) {
// 	    	$(this).css({transform: 'scale(' + coefWidth + ')'});
// 	    };

// 	    if (heightProdImg < heightProdBlock) {
// 	    	$(this).css({transform: 'scale(' + coefheight + ')'});
// 	    };

// 	});
// };
/* End Image Scale Code */

// $(document).ready(function () {

//     image_scale();
// });

// $(window).load(function () {
//     image_scale();
// });

// $(window).resize(function () {
//     image_scale();
// });


/* Add class to body to change modal Overlay styles */
$(document).ready(function () {
	$('#modalNavigation').on('show.bs.modal', function (e) {
	  $("body").addClass("menuCmsOpen");
	});
	$('#modalNavigation').on('hidden.bs.modal', function (e) {
	  $("body").removeClass("menuCmsOpen");
	});

});


$(window).on('load resize ', function(){
	var scTabMob = $(document).width() < 768;
	var heightBody =  window.innerHeight;
	var heightTopCart = $('#topCart').outerHeight(true);
	var heightBottomCart =  $('#totalCart').outerHeight(true);
	var heightTopSidebar = $('#sidebar-wrapper h2').outerHeight(true);

	return;
	if (scTabMob) {
		 var heightCart =  heightBody - heightTopCart - heightBottomCart;
		     $('#sideCart #cartContent').css('height', heightCart);
		 var heightSide =  heightBody - heightTopSidebar;
		 	 $('#sidebar-wrapper .bgMenu').css('height', heightSide);
	} else {
	  	 var heightCart =  heightBody - heightTopCart - heightBottomCart - 74;
		     $('#sideCart #cartContent').css('height', heightCart);
	     var heightSide =  heightBody - heightTopSidebar;
	     	 $('#sidebar-wrapper .bgMenu').css('height', heightSide - 74);
	};

});


